!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports["react-file-picker"] = e(require("react")) : t["react-file-picker"] = e(t.react);
}(window, function (t) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 18);
  }([function (t, e, r) {
    t.exports = r(14)();
  }, function (e, r) {
    e.exports = t;
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    function r(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    t.exports = function (t, e, n) {
      return e && r(t.prototype, e), n && r(t, n), t;
    };
  }, function (t, e, r) {
    var n = r(12),
        o = r(2);

    t.exports = function (t, e) {
      return !e || "object" !== n(e) && "function" != typeof e ? o(t) : e;
    };
  }, function (t, e) {
    function r(e) {
      return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, r(e);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(13);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && n(t, e);
    };
  }, function (t, e, r) {
    t.exports = r(17);
  }, function (t, e) {
    function r() {
      return t.exports = r = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }, r.apply(this, arguments);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(16);

    t.exports = function (t, e) {
      if (null == t) return {};
      var r,
          o,
          i = n(t, e);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);

        for (o = 0; o < a.length; o++) {
          r = a[o], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
        }
      }

      return i;
    };
  }, function (t, e) {
    function r(t, e, r, n, o, i, a) {
      try {
        var u = t[i](a),
            c = u.value;
      } catch (t) {
        return void r(t);
      }

      u.done ? e(c) : Promise.resolve(c).then(n, o);
    }

    t.exports = function (t) {
      return function () {
        var e = this,
            n = arguments;
        return new Promise(function (o, i) {
          var a = t.apply(e, n);

          function u(t) {
            r(a, o, i, u, c, "next", t);
          }

          function c(t) {
            r(a, o, i, u, c, "throw", t);
          }

          u(void 0);
        });
      };
    };
  }, function (t, e) {
    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function n(e) {
      return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? t.exports = n = function n(t) {
        return r(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : r(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e) {
    function r(e, n) {
      return t.exports = r = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, r(e, n);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    var n = r(15);

    function o() {}

    function i() {}

    i.resetWarningCache = o, t.exports = function () {
      function t(t, e, r, o, i, a) {
        if (a !== n) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var r = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e) {
    t.exports = function (t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    };
  }, function (t, e, r) {
    var n = function (t) {
      "use strict";

      var e,
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          a = o.asyncIterator || "@@asyncIterator",
          u = o.toStringTag || "@@toStringTag";

      function c(t, e, r, n) {
        var o = e && e.prototype instanceof d ? e : d,
            i = Object.create(o.prototype),
            a = new L(n || []);
        return i._invoke = function (t, e, r) {
          var n = f;
          return function (o, i) {
            if (n === p) throw new Error("Generator is already running");

            if (n === h) {
              if ("throw" === o) throw i;
              return k();
            }

            for (r.method = o, r.arg = i;;) {
              var a = r.delegate;

              if (a) {
                var u = E(a, r);

                if (u) {
                  if (u === y) continue;
                  return u;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === f) throw n = h, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = p;
              var c = s(t, e, r);

              if ("normal" === c.type) {
                if (n = r.done ? h : l, c.arg === y) continue;
                return {
                  value: c.arg,
                  done: r.done
                };
              }

              "throw" === c.type && (n = h, r.method = "throw", r.arg = c.arg);
            }
          };
        }(t, r, a), i;
      }

      function s(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = c;
      var f = "suspendedStart",
          l = "suspendedYield",
          p = "executing",
          h = "completed",
          y = {};

      function d() {}

      function v() {}

      function m() {}

      var g = {};

      g[i] = function () {
        return this;
      };

      var b = Object.getPrototypeOf,
          x = b && b(b(S([])));
      x && x !== r && n.call(x, i) && (g = x);
      var w = m.prototype = d.prototype = Object.create(g);

      function _(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function O(t) {
        var e;

        this._invoke = function (r, o) {
          function i() {
            return new Promise(function (e, i) {
              !function e(r, o, i, a) {
                var u = s(t[r], t, o);

                if ("throw" !== u.type) {
                  var c = u.arg,
                      f = c.value;
                  return f && "object" == typeof f && n.call(f, "__await") ? Promise.resolve(f.__await).then(function (t) {
                    e("next", t, i, a);
                  }, function (t) {
                    e("throw", t, i, a);
                  }) : Promise.resolve(f).then(function (t) {
                    c.value = t, i(c);
                  }, function (t) {
                    return e("throw", t, i, a);
                  });
                }

                a(u.arg);
              }(r, o, e, i);
            });
          }

          return e = e ? e.then(i, i) : i();
        };
      }

      function E(t, r) {
        var n = t.iterator[r.method];

        if (n === e) {
          if (r.delegate = null, "throw" === r.method) {
            if (t.iterator.return && (r.method = "return", r.arg = e, E(t, r), "throw" === r.method)) return y;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return y;
        }

        var o = s(n, t.iterator, r.arg);
        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
        var i = o.arg;
        return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, y) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
      }

      function j(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function P(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function L(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(j, this), this.reset(!0);
      }

      function S(t) {
        if (t) {
          var r = t[i];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                a = function r() {
              for (; ++o < t.length;) {
                if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
              }

              return r.value = e, r.done = !0, r;
            };

            return a.next = a;
          }
        }

        return {
          next: k
        };
      }

      function k() {
        return {
          value: e,
          done: !0
        };
      }

      return v.prototype = w.constructor = m, m.constructor = v, m[u] = v.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m, u in t || (t[u] = "GeneratorFunction")), t.prototype = Object.create(w), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, _(O.prototype), O.prototype[a] = function () {
        return this;
      }, t.AsyncIterator = O, t.async = function (e, r, n, o) {
        var i = new O(c(e, r, n, o));
        return t.isGeneratorFunction(r) ? i : i.next().then(function (t) {
          return t.done ? t.value : i.next();
        });
      }, _(w), w[u] = "Generator", w[i] = function () {
        return this;
      }, w.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = S, L.prototype = {
        constructor: L,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(P), !t) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return u.type = "throw", u.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                u = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var c = n.call(a, "catchLoc"),
                  s = n.call(a, "finallyLoc");

              if (c && s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (c) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), P(r), y;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                P(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, r, n) {
          return this.delegate = {
            iterator: S(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), y;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = n;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (t, e, r) {
    "use strict";

    r.r(e);

    var n = r(3),
        o = r.n(n),
        i = r(4),
        a = r.n(i),
        u = r(5),
        c = r.n(u),
        s = r(6),
        f = r.n(s),
        l = r(2),
        p = r.n(l),
        h = r(7),
        y = r.n(h),
        d = r(1),
        v = r.n(d),
        m = r(0),
        g = r.n(m),
        b = function (t) {
      function e(t) {
        var r;
        return o()(this, e), (r = c()(this, f()(e).call(this, t)))._handleUpload = r._handleUpload.bind(p()(r)), r;
      }

      return y()(e, t), a()(e, [{
        key: "_handleUpload",
        value: function value(t) {
          var e = t.target.files[0];
          this.props.onChange(e), this.fileInput.value = null;
        }
      }, {
        key: "render",
        value: function value() {
          var t = this;
          return v.a.createElement("div", {
            style: this.props.style
          }, v.a.createElement("input", {
            type: "file",
            style: {
              display: "none"
            },
            onChange: this._handleUpload,
            ref: function ref(e) {
              return t.fileInput = e;
            }
          }), v.a.cloneElement(this.props.children, {
            onClick: function onClick() {
              return t.fileInput.click();
            }
          }));
        }
      }]), e;
    }(v.a.Component);

    b.propTypes = {
      style: g.a.object,
      children: g.a.node.isRequired,
      onChange: g.a.func.isRequired
    };

    var x = b,
        w = function (t) {
      function e(t) {
        var r;
        return o()(this, e), (r = c()(this, f()(e).call(this, t)))._validate = r._validate.bind(p()(r)), r;
      }

      return y()(e, t), a()(e, [{
        key: "_validate",
        value: function value(t) {
          var e = this.props,
              r = e.onError,
              n = e.onChange,
              o = e.maxSize,
              i = e.extensions;

          if (t) {
            if (i) {
              var a = t.name.split(".").pop().toLowerCase();
              if (!i.map(function (t) {
                return t.toLowerCase();
              }).includes(a)) return void r("Must upload a file of type: ".concat(i.join(" or ")));
            }

            var u = 1e6 * o;
            t.size > u ? r("File size must be less than ".concat(o, " MB.")) : n(t);
          } else r("Failed to upload a file.");
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.props,
              e = t.children,
              r = t.style;
          return v.a.createElement(x, {
            onChange: this._validate,
            style: r
          }, e);
        }
      }]), e;
    }(v.a.Component);

    w.propTypes = {
      children: g.a.node.isRequired,
      onChange: g.a.func.isRequired,
      onError: g.a.func.isRequired,
      maxSize: g.a.number,
      extensions: g.a.array,
      validateContent: g.a.func,
      style: g.a.object
    }, w.defaultProps = {
      maxSize: 2
    };
    var _ = w,
        O = r(9),
        E = r.n(O),
        j = r(10),
        P = r.n(j),
        L = r(8),
        S = r.n(L),
        k = r(11),
        T = r.n(k);

    function R(t, e) {
      var r = e.minWidth,
          n = e.maxWidth,
          o = e.minHeight,
          i = e.maxHeight;
      return new Promise(function (e, a) {
        var u = new Image();
        u.src = t, u.onload = function () {
          (u.width < r || u.height < o) && a(new Error("The uploaded image is too small. Must be at least ".concat(r, "px by ").concat(o, "px."))), (u.width > n || u.height > i) && a(new Error("The uploaded image is too large. Must be no more than ".concat(n, "px by ").concat(i, "px."))), e(!0);
        }, u.onerror = function () {
          return a(new Error("There was an error uploading the image"));
        };
      });
    }

    function C(t) {
      return new Promise(function (e, r) {
        var n = new FileReader();
        n.readAsDataURL(t), n.onloadend = function (t) {
          return e(t.target.result);
        }, n.onerror = function () {
          return r(new Error("There was an error uploading the file"));
        };
      });
    }

    var I = function (t) {
      function e(t) {
        var r;
        return o()(this, e), (r = c()(this, f()(e).call(this, t)))._handleImg = r._handleImg.bind(p()(r)), r;
      }

      return y()(e, t), a()(e, [{
        key: "_handleImg",
        value: function () {
          var t = T()(S.a.mark(function t(e) {
            var r, n, o, i, a;
            return S.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return r = this.props, n = r.onChange, o = r.onError, i = r.dims, t.prev = 1, t.next = 4, C(e);

                  case 4:
                    return a = t.sent, t.next = 7, R(a, i);

                  case 7:
                    n(a), t.next = 13;
                    break;

                  case 10:
                    t.prev = 10, t.t0 = t.catch(1), o(t.t0.message);

                  case 13:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this, [[1, 10]]);
          }));
          return function (e) {
            return t.apply(this, arguments);
          };
        }()
      }, {
        key: "render",
        value: function value() {
          var t = this.props,
              e = t.children,
              r = P()(t, ["children"]);
          return Reflect.deleteProperty(r, "onChange"), v.a.createElement(_, E()({
            onChange: this._handleImg
          }, r), e);
        }
      }]), e;
    }(v.a.Component);

    I.propTypes = {
      children: g.a.node.isRequired,
      onChange: g.a.func.isRequired,
      onError: g.a.func.isRequired,
      dims: g.a.shape({
        minWidth: g.a.number.isRequired,
        maxWidth: g.a.number.isRequired,
        minHeight: g.a.number.isRequired,
        maxHeight: g.a.number.isRequired
      }).isRequired
    };
    var q = I;
    r.d(e, "FilePicker", function () {
      return _;
    }), r.d(e, "ImagePicker", function () {
      return q;
    });
  }]);
});